import { useState } from 'react';

type JsonViewerProps = {
  object: any;
  startCollapsed?: boolean;
};
export const JsonViewer = (props: JsonViewerProps) => {
  const [collapse, setCollapse] = useState(props.startCollapsed == undefined ? true : false);

  return (
    <div>
      <div
        onClick={() => {
          setCollapse(!collapse);
        }}>
        Toggle Json View
      </div>
      {!collapse && <pre>{JSON.stringify(props.object, null, 2)}</pre>}
    </div>
  );
};
